import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../app-context';
import { ALL, DAYS_YEAR, GET_AMZ_PRODUCT_URL } from '../../common/constants';
import { getInvAttribute, getPrdRetTrendChart } from '../amazon.services';
import { FormControl, FormControlLabel, Grid, Radio, RadioGroup } from '@mui/material';
import SearchPanel from '../../../components/search-panel/search-panel.component';
import IDropdown from '../../../components/text-component/dropdown/i-dropdown.component';
import Chart from 'react-google-charts';
import IDateField from '../../../components/text-component/i-datefield/i-datefield.component';
import dayjs from 'dayjs';
import { formatTo0Decimal } from '../../common/util.services';

const ProductReturnTrendMonthly = () => {
  const appContext = useContext(AppContext);
  const [product, setProduct] = useState(ALL);
  const [color, setColor] = useState(ALL);
  const [size, setSize] = useState(ALL);
  const [pack, setPack] = useState(ALL);
  const [colorList, setColorList] = useState([]);
  const [sizeList, setSizeList] = useState([]);
  const [packList, setPackList] = useState([]);
  const [returnData, setReturnData] = useState();
  const [type, setType] = useState('Value');
  const [searchData, setSearchData] = useState<any>({startDate: dayjs().subtract(DAYS_YEAR, 'day'), endDate: dayjs(),
                                                     product: ALL, color: ALL, size: ALL, pack: ALL});
  const [startDate, setStartDate] = useState(searchData.startDate);
  const [endDate, setEndDate] = useState(searchData.endDate);
  const options = { legend: {position: 'none', alignment: 'center'}, colors: ["purple"], tooltip: { trigger: "none" } };

  useEffect(() => {
    getData();
  }, []);

  function getData() {
    let filter = {startDate: startDate, endDate: endDate, product: product, color: color, 
                  size: size, pack: pack, type: type, aggregation: 'Monthly'};
    getPrdRetTrendChart(filter, appContext,
      (response: any) => {
        let rertunData: any = [["Product", "Return", {role: "annotation"}]];
        for(let i = 0; i < response.data.length; ++i) {
          let data: any = [response.data[i][0], +response.data[i][1], formatTo0Decimal(response.data[i][1]) + '%'];
          rertunData.push(data);
        }
        setReturnData(rertunData);
        appContext.setShowLoader(false);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
      });
  };

  const search = (data: any) => {
    setSearchData(data);
    getData();
  }

  const updateAttributeList = (invProduct: any) => {
    getInvAttribute(invProduct, appContext,
      (response: any) => {
        setColorList(response.data[0]);
        setSizeList(response.data[1]);
        setPackList(response.data[2]);
        appContext.setShowLoader(false);
        appContext.setSuccessMessage(response.message)
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
      });
  }

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setType((event.target as HTMLInputElement).value);
  }

  const getSearchComponent = () => {
    return <SearchPanel search={search} formData={searchData}>
      <Grid container spacing={1} width={1000}>
        <Grid xs={2}>
          <IDateField name='startDate' label='Start Date' timeZone="America/Los_Angeles"
            onActionEvent={(e: any) => setStartDate(e)}/>
        </Grid>
        <Grid xs={2}>
          <IDateField name='endDate' label='End Date' timeZone="America/Los_Angeles"
            onActionEvent={(e: any) => setEndDate(e)}/>
        </Grid>
        <Grid xs={1.5}>
          <IDropdown name='product' label='Product' url={GET_AMZ_PRODUCT_URL} allItemRequired={true} required={true}
            onChangeEvent={(e: any) => {setProduct(e.target.value); setColor(ALL); setSize(ALL); 
                                        setPack(ALL); updateAttributeList(e.target.value);}} />
        </Grid>
        <Grid xs={1.5}>
          <IDropdown name='color' label='Color' itemList={colorList} allItemRequired={true} required={true}
            onChangeEvent={(e: any) => {setColor(e.target.value)}}/>
        </Grid>
        <Grid xs={1.5}>
          <IDropdown name='size' label='Size' itemList={sizeList} allItemRequired={true} required={true}
            onChangeEvent={(e: any) => {setSize(e.target.value)}}/>
        </Grid>
        <Grid xs={1.5}>
          <IDropdown name='pack' label='Pack' itemList={packList} allItemRequired={true} required={true}
            onChangeEvent={(e: any) => {setPack(e.target.value)}}/>
        </Grid>
        <Grid xs={2} sx={{ pl: 2, display: 'flex', alignItems: 'center' }}>
          <FormControl>
            <RadioGroup defaultValue="Val" name="type" row={true} onChange={handleChange}>
              <FormControlLabel value="Qty" control={<Radio />} label="Qty" />
              <FormControlLabel value="Val" control={<Radio />} label="Val" />
            </RadioGroup>
          </FormControl>
        </Grid>
      </Grid>
    </SearchPanel>
  }

  return <>
    {getSearchComponent()}
    <Chart chartType="ColumnChart" height={"400px"} width="1000px" data={returnData} options={options}/>
  </>
}

export default ProductReturnTrendMonthly;

